module.exports = __webpack_public_path__ + "944335fd353f61ed8ac0191c96e97957.svg";